module.exports = __webpack_public_path__ + "static/media/logos.bef31d8c.png";